export default __webpack_public_path__ + "static/media/refreshments.180d4815.svg";